import { inject, injectable } from 'tsyringe';
import { type ICompanyUserTokenRepository } from 'application/repositorySchemas/ICompanyUserTokenRepository';
import {
    type ICompanyUserAddCompanyRepository,
    type ICompanyUserAddCompanyDraft,
} from 'application/repositorySchemas/ICompanyUserAddCompanyRepository';
import { type ICompanyUserAddCompanyClient } from 'interfaceAdapter/gatewaySchemas/ICompanyUserAddCompanyClient';

@injectable()
export class CompanyUserAddCompanyRepository implements ICompanyUserAddCompanyRepository {
    constructor(
        @inject('ICompanyUserTokenRepository')
        public readonly companyUserToken: ICompanyUserTokenRepository,
        @inject('ICompanyUserAddCompanyClient')
        public readonly companyUserAddCompanyClient: ICompanyUserAddCompanyClient,
    ) {}

    public async addCompany(draft: ICompanyUserAddCompanyDraft): Promise<number> {
        const { data, message } = await this.companyUserAddCompanyClient.post({
            token: this.companyUserToken.get() || '',
            ...draft,
        });
        if (message) {
            throw new Error(message);
        }
        return data.company_id;
    }
}
